module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_uneedcom.0e6e50d81546ac3cf2eee0da2c0d5c8c.png";